import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

const EsigneringStatusOptions =[
    {Value:0,label:<IntlMessages id="Created"/>},
    {Value:2,label:<IntlMessages id="Label.Sent"/>},
    {Value:3,label:<IntlMessages id="Label.Shown"/>},
    {Value:5,label:<IntlMessages id="Label.Singed"/>},
    {Value:1,label:<IntlMessages id="Label.Recalled"/>},
    {Value:4,label:<IntlMessages id="Label.Timeout"/>},
    {Value:7,label:<IntlMessages id="Label.Rejected2"/>},
    {Value:6,label:<IntlMessages id="Label.Rejected"/>},
]
class AvtalsTyp extends Component {
    state={
        EsigneringStatus:0
    }
    getAvtalType=(e)=>{
        let Meta = "EsigneringStatus"
        this.props.onChangeHandleMulti(Meta,e.target.value)        
    }
    render() {
        return (
            <div>
                <form>
                <div style={{ height: 'auto', paddingTop: '10px' }}>
                <TextField
                    select
                    label={<IntlMessages id="Input.Status"/>}
                    variant="outlined"
                    size="small"
                    value={this.state.EsigneringStatus}
                    fullWidth
                    onChange={this.getAvtalType}
                    SelectProps={{native: true,}}
                    InputLabelProps={{shrink: true,}}
                >
                    <option Key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
                    {EsigneringStatusOptions.map((option) => (
                        <option key={option.Value} value={option.Value}>
                            {option.label}
                        </option>
                    ))}
                </TextField>
            </div>
        </form>
            </div>
        );
    }
}

export default (AvtalsTyp);
